 <template>
    <el-dialog :visible.sync="visible" width="350px" append-to-body title="编辑组织/部门" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">

        
        <el-form :model="form" size="mini" label-position="top" v-loading="loading">
            
            
            <el-form-item label="上级组织">
                <hrm-organize-cascader v-model="form.parent" placeholder="请选择上级组织" />
            </el-form-item>

            
            <el-form-item label="组织/部门名称" :rules="[{ required: true, message: '必填项' }]" :error="formError.name?.toString()" prop="name">
                <el-input v-model="form.name" placeholder="请填写组织/部门名称" clearable />
            </el-form-item>

        </el-form>
        <span slot="footer">
            <el-button size="mini" @click="Close()">取 消</el-button>
            <el-button size="mini" type="primary" @click="SubmitForm()" :loading="loading">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>

export default {
    data () {
        return {
                        visible: false,
            loading: false,

            formError: {},
            form: {
                id: null,
                name: null,
                parent: null
            }
        }
    },

    methods: {

        
       
        Open (date) {
            this.visible = true
            this.form.id = date.id
            this.form.name = date.name
            this.form.parent = date.parent
        },
        Close() {
            this.loading = false
            this.visible = false
        },
        SubmitForm() {
                        this.loading = true
            this.formError = {}

                        this.$http.post('/9api/hrm/organize/update', this.form).then(rps => {
                                this.loading = false

                                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }
                
                                if (rps.data.state == 'success') {
                    this.$emit('onChange', rps.data.body)
                    this.Close()
                }
            })
        }
    }  
}
</script>